(function () {
    "use strict";

    function workflowFactory() {
        var data = {
            name: "",
            id: 0,
            idUser: "",
            token: ""
        };

        return data;
    }

    workflowFactory.$inject = [];

    angular.module("sphforms.workflow")
        .factory("sphforms.workflowFactory", workflowFactory);
}());